import styled, { css } from 'styled-components';

import { overlay } from 'styled';

export const LoadingWrapper = styled.div`
  width: 100px;
  height: 100px;
`;

export const ModalStyles = css`
  width: 360px !important;
  height: 240px !important;

  border-radius: 18px;

  .ant-modal-close {
    display: none;
  }

  .ant-modal-content {
    border-radius: 18px;
    height: 240px !important;
  }

  .ant-modal-body {
    height: 240px !important;
    padding: 48px !important;
  }

  .ant-modal-header {
    display: none !important;
  }

  .ant-modal-body {
    overflow: scroll;
    ${overlay}
  }
`;

export const WrapperContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalMobileStyles = css`
  width: 260px !important;
  height: 140px !important;

  border-radius: 18px;

  .ant-modal-close {
    display: none;
  }

  .ant-modal-content {
    border-radius: 18px;
    height: 200px !important;
  }

  .ant-modal-body {
    height: 200px !important;
    padding: 18px !important;
  }

  .ant-modal-header {
    display: none !important;
  }

  .ant-modal-body {
    overflow: scroll;

    ${overlay}
  }
`;
